import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { BONOS } from './salesData';

/**
 * LOS 5 BONOS. No son "cinco PDFs gratis": son la respuesta a cómo se pasa de
 * aprender las recetas a poder presentar y ofrecer las cookies.
 */
export function BonosSection() {
  return <section id="bonos" className="scroll-mt-24 overflow-hidden bg-bone py-14 sm:py-20" aria-labelledby="bonos-title" data-id="element-52" data-mp="ydrum5dzx0pw">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-53" data-mp="tdndqe96e3z5">
        <div className="max-w-3xl" data-id="element-54" data-mp="ofvkngwsobtd">
          <SectionTag data-id="element-55" data-mp="oizvuy8og7tj">Los 5 bonos incluidos</SectionTag>
          <h2 id="bonos-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-56" data-mp="kg36moomtdgm">
            No solo aprendés a hacerlas.{' '}
            <span className="text-[#F47A2A]" data-id="element-57" data-mp="2errrf7hjoa8x">
              También te ayudamos a dar tus primeros pasos para ofrecerlas.
            </span>
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-58" data-mp="qveflpupvw6p">
            Con tu compra recibís 5 recursos complementarios pensados para ayudarte a organizarte,
            evitar errores, presentar mejor tus cookies y empezar a construir tu catálogo.
          </p>
        </div>

        <ul className="mt-9 grid gap-5" data-id="element-59" data-mp="mtjfgooivoui">
          {BONOS.map((bono, index) => <motion.li key={bono.id} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-5 rounded-5xl bg-ivory p-5 shadow-bakery-sm sm:grid-cols-[minmax(0,10rem)_1fr] sm:items-center sm:gap-7 sm:p-7 lg:grid-cols-[minmax(0,12rem)_1fr]" data-id="element-60" data-mp="1ajdnmsxwcp8f" data-mpi={index}>
              <div className="relative mx-auto w-[9rem] sm:mx-0 sm:w-full" data-id="element-61" data-mp="1tgydo3cedtum">
                <img src={bono.image} alt={`Portada del ${bono.label}: ${bono.title}.`} loading="lazy" decoding="async" className="aspect-[3/4] w-full rounded-2xl bg-cream object-contain shadow-bakery-sm" data-id="element-62" data-mp="1ya16uad9j1aa" />
                <span className="absolute -top-2 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#F47A2A] px-3 py-1 font-sans text-[0.5rem] font-bold uppercase tracking-[0.12em] text-white shadow-bakery-sm sm:left-2 sm:translate-x-0" data-id="element-63" data-mp="1y57i5r4i4dm8">
                  Bono gratis
                </span>
              </div>

              <div className={index % 2 === 1 ? 'sm:order-first sm:text-right' : ''} data-id="element-64" data-mp="1kdawo5xc91yt">
                <p className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-caramel sm:text-[0.64rem]" data-id="element-65" data-mp="1fgkgzjpg48dx">
                  {bono.label}
                </p>
                <h3 className="mt-2 font-display text-[1.2rem] leading-tight text-charcoal sm:text-[1.6rem]" data-id="element-66" data-mp="15gtkxdl8llbq">
                  {bono.title}
                </h3>
                <p className="mt-3 font-sans text-[0.88rem] leading-relaxed text-charcoal-mid" data-id="element-67" data-mp="3d4518uewf66m">
                  {bono.body}
                </p>
                <p className="mt-4 inline-block rounded-2xl bg-caramel-pale px-4 py-2.5 font-sans text-[0.8rem] font-bold leading-snug text-charcoal sm:text-[0.86rem]" data-id="element-68" data-mp="3h3vo4n1b125v">
                  {bono.angle}
                </p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}